var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panelFilesWrapper row"},_vm._l((_vm.files),function(file){return _c('div',{staticClass:"medium-6 columns"},[_c('all-bubble',{attrs:{"file":file}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }